export default {"src":"/_next/static/media/tomatillo.3a493de6.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};